import {onFind} from "@elements/init-modules-in-scope";
import {findAllIn, closest, on} from '@elements/dom-utils';
import asyncAppend from "@elements/async-append";
import axios from "axios";
import {resultTracking} from "@elements/tracking";

const selectors = {
    base: '.js-cart',

    cartItem: '.js-cart__item',
    cartBtn: '.js-cart__btn',

    target: '.js-cart__result',
    loading: '.js-cart__loading',
};

export function init () {
    onFind(selectors.base, function (el) {
        onFind(selectors.cartItem, function (cartItem) {
            let cartBtns = findAllIn(selectors.cartBtn, cartItem);
            let baseElement = closest(selectors.base, cartItem);
            let cartURL = baseElement.dataset.cartUrl;

            cartBtns.map(function(cartBtn) {
                on('click', function (evt) {
                    evt.preventDefault();

                    let data = {
                        cartId: cartBtn.dataset.cartId,
                        action: "remove",
                    };

                    if (cartURL) {
                        let pendingRequest = null;
                        pendingRequest = axios({method: 'POST', url: cartURL, data: data});
                        loadCartContent(baseElement, pendingRequest);
                    } else {
                        console.warn("checkout-cart.js: no cartURL is set");
                    }
                }, cartBtn);
            });
        })
    });
}

export function loadCartContent(baseElement, pendingRequest) {

    let results = findAllIn(selectors.target, baseElement);
    let targetsByResultId = {};

    results.forEach((element) => {
        let resultId = element.dataset.cartResultId;
        if (targetsByResultId[resultId]) {
            targetsByResultId[resultId] = [...targetsByResultId[resultId], element];
        } else {
            targetsByResultId[resultId] = [element];
        }
    });

    asyncAppend({
        target: targetsByResultId,
        loading: findAllIn(selectors.loading, baseElement),
    }, pendingRequest.then((x) => x.data)).then((data) => {
        if(data.cartSum) {
            if(document.getElementsByClassName('js-cart-counter')[0]) {
                document.getElementsByClassName('js-cart-counter')[0].innerHTML = data.cartSum;
            }
        }

        // execute resultTracking
        // data contains and executes _trackingScript
        if(data.responseTrackingData && window._trackingData) {
            window.dataLayer = window['dataLayer'] || [];
            window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            resultTracking(data);
        }
    });
}

